<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
        <div class="container px-4">
          <div class="mb-2 pb-1">
            <div class="row">
              <div class="my-2 col-12" v-if="type == 'ORDER' && (data.module.slug=='room-dining' || data.module.slug=='extra-amenities' || data.module.slug=='spa')">
                <p class="mb-0 body-2 font-regular">{{$t('hotel.concierge.invoice')}}:</p>
                <p class="mb-0 body-2-2 font-bold text-14">{{data.invoice}}</p>
              </div>
              <div class="my-2" :class="type=='SERVICE' ? 'col-12' : 'col-6'">
                <p class="mb-0 body-2 font-regular">{{$t('hotel.concierge.order')}}:</p>
                <p class="mb-0 body-2-2 font-bold text-14">{{type == 'SERVICE' ? 'Maintenance Service' : data.module.name}}</p>
              </div>
              <div v-if="type == 'ORDER'" class="col-6 my-2">
                <p class="mb-0 body-2 font-regular">{{$t('hotel.concierge.status')}}:</p>
                <p class="mb-0 body-2-2 font-bold text-14" :class="status.class_name">{{status.text}}</p>
              </div>
              <div class="col-6 my-2">
                <p class="mb-0 body-2 font-regular">{{$t('general.date')}}:</p>
                <p class="mb-0 body-2-2 font-bold">{{formatDate(data.created_at)}}</p>
              </div>
              <div v-if="type == 'SERVICE'" class="col-6 my-2">
                <p class="mb-0 body-2 font-regular">{{$t('hotel.concierge.status')}}:</p>
                <p class="mb-0 body-2-2 font-bold text-14" :class="status.class_name">{{status.text}}</p>
              </div>
              <div v-if="type == 'ORDER' && data.module.slug!='laundry'" class="col-6 my-2">
                <p class="mb-0 body-2 font-regular">{{$t('general.price')}}:</p>
                <p class="mb-0 body-2-2 font-bold text-truncate">{{formatCurrency(data.total_payment)}}</p>
              </div>
            </div>
          </div>
          <template v-if="type!='SERVICE'">
            <p class="mb-3 body-3-3 text-16 font-bold pt-2">{{$t('hotel.concierge.your-order')}} <template v-if="data.module.slug == 'laundry'">({{data.module.type}})</template></p>
            <template v-if="data.module.slug == 'experience'">
              <div class="rounded-10 box-shadow-bold mb-3 border w-100">
                <div class="row slim-grid-row">
                  <div class="col-4">
                    <img :src="data.tx_detail_list[0].merchant_relation.image_url" class="w-100 rounded-10 object-fit w-100">
                  </div>
                  <div class="col-8">
                    <div class="py-2">
                      <p class="mb-0 body-2 font-bold text-black">{{data.tx_detail_list[0].merchant_relation.name}}</p>
                      <p class="mb-0 body-2 font-semibold">{{defaultFormatDate(data.tx_detail_list[0].service_date)}}</p>
                      <p class="mb-0 body-2-2 text-truncate d-inline-block font-semibold align-bottom mr-1">{{data.tx_detail_list.length}} Ticket</p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="data.module.slug == 'spa'" class="rounded-6 box-shadow-bold mb-4 border w-100 py-2">
              <div class="row no-gutters">
                <div class="col-2 align-self-center text-center">
                  <img src="../../../../assets/img/icon/calendar-green.png" width="18">
                </div>
                <div class="col-10 align-self-center">
                  <p class="mb-0 body-3-3">Service date</p>
                  <p class="mb-0 text-green body-2-4">{{defaultFormatDate(data.tx_detail_list[0].service_date)}}</p>
                </div>
              </div>
              <!-- <p class="mb-0 body-3-3-1">Click to change</p> -->
            </div>
            <template v-for="item_order in data.tx_detail_list">
              <historyDetailItem :data="item_order" :module="data.module.slug" :module_type="data.module.type"></historyDetailItem>
            </template>
          </template>
          <template v-else>
            <p class="mb-2 pt-2 body-3-3 text-14 font-bold">{{$t('hotel.concierge.ms-detail.the-problem')}}</p>
            <input type="text" class="form-control body-2 rounded-6 text-14 mb-2 bg-light-page cursor-disable" v-model="data.service_module_merchant.name" readonly label="name">
            <template v-if="data.label != ''">
              <p class="mb-2 pt-2 body-3-3 text-14 font-bold">{{$t('hotel.concierge.ms-detail.more-details')}}</p>
              <input type="text" class="form-control body-2 rounded-6 text-14 mb-2 bg-light-page cursor-disable" v-model="data.label" readonly label="name">
            </template>
            <p class="mb-2 mt-4 body-3-3 text-14 font-bold">{{$t('hotel.concierge.ms-detail.description')}}</p>
            <textarea class="form-control px-2 body-2 rounded-6 text-14 mb-2 bg-light-page cursor-disable" rows="3" v-model="data.description" readonly=""></textarea>
            <template v-if="data.image_list.length > 0">
              <p class="mb-2 mt-4 body-3-3 text-14 font-bold">{{$t('hotel.concierge.ms-detail.photo-of-problem')}}</p>
              <div class="w-100 bg-light-page border rounded-6 cursor-pointer" @click="is_detail_photo = true">
                <img :src="data.image_list[0].image_url" class="w-100 object-fit rounded-6" style="height: 190px">
              </div>
            </template>
          </template>
        </div>
        <template v-if="type!='SERVICE'">
          <div class="container px-4 pt-2 mb-3">
            <p class="mb-3 body-3-3 text-16 font-bold">{{$t('hotel.concierge.order-note')}}</p>
            <textarea v-model="data.notes" class="form-control px-2 body-2 rounded-6 text-14 mb-2 bg-light-page cursor-disable" readonly rows="3"></textarea>
            <template v-if="(data.module.slug == 'laundry' && data.module.type == 'pcs') || data.module.slug != 'laundry'">
              <p class="mb-3 pt-4 body-3-3 text-16 font-bold">{{$t('hotel.concierge.price-detail')}}</p>
              <div class="box-shadow-primary p-3 border rounded-6 bg-light">
                <div class="row mb-2 pb-1">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.sub-total')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(data.total_amount)}}</p>
                  </div>
                </div>
                <div class="row mb-2 pb-1" v-if="Math.abs(data.total_discount) > 0">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold text-green">{{$t('hotel.concierge.discount')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold text-green">- {{formatCurrency(Math.abs(data.total_discount))}}</p>
                  </div>
                </div>
                <div class="row mb-2 pb-1">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.tax-service')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(tax_service)}}</p>
                  </div>
                </div>
                <div class="border-top">
                  <div class="row pt-2">
                    <div class="col-6">
                      <p class="mb-0 body-1-2 font-bold">{{$t('hotel.concierge.total')}}</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-1-2 font-bold">{{formatCurrency(data.total_payment)}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="container px-4 pt-4 mb-2 mt-2">
            <router-link :to="'/'+getMerchant().code+'/concierge/'+data.module.slug">
              <button type="button" class="button-secondary w-100">{{$t('hotel.action.order-again')}}</button>
            </router-link>
          </div>
        </template>
        <!-- <template v-else>
          <div class="container px-4 pt-4 pb-4">
            <p class="mb-3 body-3-3 text-16 font-bold">Responsible Officer</p>
            <div class="rounded-10 p-4" style="box-shadow: rgb(0 0 0 / 18%) 0px 12px 38px 0px">
              <div class="row slim-grid-row">
                <div class="col-12 align-self-center">
                  <div class="d-inline-block align-middle mr-2 pr-1">
                    <div class="border-2-green bg-white rounded-50 mx-auto mb-0 cursor-pointer">
                      <img src="../../../../assets/img/icon/namaste.png" class="rounded-50 d-block m-auto width-50px object-fit">
                    </div>
                  </div>
                  <div class="d-inline-block align-middle" style="width: 60%;">
                    <p class="mb-0 body-1-4 text-16 text-truncate">Asep Sukirman</p>
                    <p class="mb-0 body-2 text-truncate">Specialist AC</p>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <button type="button" class="button-primary w-100" @click="togglePopUp(true)">Rate Service</button>
              </div>
            </div>
          </div>
        </template> -->
      </template>
    </template>
    <!-- <template v-if="type=='SERVICE'"> -->
      <!-- <transition name="fade">
        <template v-if="is_popup != ''">
          <div class="position-relative" style="z-index: 1039">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="bg-white py-4 rounded-top-6">
                        <div class="px-4">
                          <div class="row pb-3 border-bottom slim-grid-row">
                            <div class="col-1">
                              <img src="../../../../assets/img/icon/close.png" width="14" class="cursor-pointer d-inline-block" @click="is_popup = false">
                            </div>
                            <div class="col-11">
                              <p class="mb-0 body-2-2 font-bold text-16 text-truncate w-80 d-inline-block position-relative" style="top: 2px">Rate Service Work</p>
                            </div>
                          </div>
                        </div>
                        <MaintenanceServiceReview></MaintenanceServiceReview>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </transition> -->
      <!-- Detail Photo Profile-->
      <!-- <transition name="fade">
        <template v-if="is_detail_photo">
          <div class="position-relative z-index-1045">
            <div class="row no-gutters justify-content-center">
              <div class="position-fixed w-100 d-block nav-bottom" style="top: 16%">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="bg-white rounded-top-3">
                        <div class="w-100">
                          <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-3 cursor-pointer position-absolute" width="33" style="z-index: 1049;right: 0" @click="isPopUp(false)">
                          <div class="w-100">
                            <img :src="data.image_list[0].image_url" class="d-block m-auto w-100">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </transition> -->
    <!-- </template> -->
    <!-- BG Pop Up -->
    <template v-if="is_popup || is_detail_photo">
      <transition name="fade">
        <div class="position-relative z-index-1038">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 position-relative">
                    <div class="">
                      <div class="w-100 py-2 px-2" 
                        @click="isPopUp(false)"
                        style="height: 100vh;background-color: #00000099">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Flickity from 'vue-flickity';
  import historyDetailItem from '@/components/hotel/concierge/general/historyDetailItem'
  import img_food1 from '../../../../assets/img/restaurant/food (1).jpg'
  import img_food2 from '../../../../assets/img/restaurant/food (2).jpg'
  import img_food3 from '../../../../assets/img/restaurant/food (3).jpg'
  import {get} from '@/services/index.js';
  import moment from 'moment'
  import {formatCurrency,formatDate} from '@/utils/index.js'

  export default{
    components: {
      Flickity,
      historyDetailItem
    },
    props: ['trx_id', 'type'],
    data() {
      return {
        is_popup: '',
        is_detail_photo: false,
        is_load: true,
        error: '',
        data: {}
      }
    },
    computed:{
      status(){
        let data = {
          class_name : 'text-orange',
          text : this.$t('hotel.concierge.waiting')
        }
        if(Object.keys(this.data).length > 0){
          if(this.data.status == 'PENDING'){
            data.class_name = 'text-orange'
            data.text = this.$t('hotel.concierge.waiting')
          }else if(this.data.status == 'ONPROGRESS'){
            data.class_name = 'text-info'
            data.text = this.$t('hotel.concierge.on-progress')
          }else if(this.data.status == 'COMPLETE'){
            data.class_name = 'text-green'
            data.text = this.$t('hotel.concierge.complete')
          }else if(this.data.status == 'CANCELLED'){
            data.class_name = 'text-danger'
            data.text = this.$t('hotel.concierge.cancelled')
          }else{
            data.class_name = 'text-orange'
            data.text = this.data.status
          }
        }
        return data
      },
      tax_service(){
        let tax_service = Number(this.data.total_taxes) + Number(this.data.total_service)
        return this.type == 'service' ? 0 : parseInt(tax_service)
      }
    },
    mounted(){
      this.loadDetailData()
    },
    methods: {
      ...mapGetters(['getMerchant','getConciergeAuth']),
      formatDate(date){
        return moment(date).format('hh:mm, DD MMM YYYY');
      },
      defaultFormatDate(date){
        return formatDate(date)
      },
      formatCurrency(price){
        return formatCurrency(price)
      },
      togglePopUp(data){
        this.is_popup = data
      },
      isPopUp(data){
        this.is_popup = data
        this.is_detail_photo = data
      },

      loadDetailData(){
        this.is_load = true
        let uri_type = this.type == 'SERVICE' ? 'tx-service/' : 'tx-order/'
        let uri = uri_type+this.trx_id
        get("CONCIERGE",uri,{
          pms_detail_id: this.getConciergeAuth().detail_id,
          folio_no: this.getConciergeAuth().folio,
          merchant_id: this.getMerchant().id,
        },'concierge_pin').then(response=>{
          let res = response.data
          if(res.success){
            this.data = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
    },
  }
</script>
<style scoped>
.bg-light-page{
  background-color: #FAFAFC!important
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/historyDetail.vue